

export const getZipcodes = (zipcodePrediction: any) => {
    return zipcodePrediction.map((item: string) => item.split('_')[0]).join(',')
}